import { PropsWithChildren } from 'react'

import { combineClassnames } from 'app/common/presentation/combineClassnames'

import styles from './Card.module.scss'
import CardHeader, { CardHeaderProps } from './CardHeader'

type CardProps = PropsWithChildren<CardHeaderProps>

const Card = ({ children, className, ...headerProps }: CardProps) => (
  <section className={combineClassnames(styles.card, className)}>
    <CardHeader {...headerProps} className={styles.header} />
    {children}
  </section>
)

export default Card
